import { SET_CONTENT, GET_CONTENT, CONTENT_ERROR } from "../actions/types";

const initialState = {
  content: null,
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_CONTENT:
      return {
        ...state,
        content: payload,
        loading: false
      };
    case SET_CONTENT:
      return {
        ...state,
        content: payload,
        loading: false
      };
    case CONTENT_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
